import styled from 'styled-components';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const Field = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${theme.colors.neutral['200']}`,
  display: 'flex',
  alignItems: 'center',
  minHeight: 72,
}));

export const Label = styled(Text).attrs({ as: 'dt' })(({ theme }) => ({
  flex: 1,
  flexShrink: 0,
  paddingLeft: 32,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  fontWeight: 500,
  color: theme.colors.neutral['500'],
}));

export const Value = styled(Text).attrs({ as: 'dd' })({
  flex: 1,
  flexShrink: 0,
  paddingLeft: 16,
  paddingRight: 32,
  paddingTop: 16,
  paddingBottom: 16,
  fontWeight: 500,
});
